import { convertDecimalToFraction } from "../../util/formulas/convertDecimalToFraction";

function calculateDLO(
  stiles: string,
  stilesAndRails: string,
  lockRail: string,
  panelWidth: number,
  panelHeight: number,
  doorType: string,
  requireTradLockStile: boolean,
  swingDirection: string,
) {
  const euroStile = 3.4375;
  const tradStile = 4.75;
  const slimStile = 2.5;
  const picoStile = 1.875;

  let sideStiles: number = 0;
  let topRail: number;

  var glassWidthDD = "";

  switch (stiles) {
    case "Traditional":
      sideStiles = tradStile;
      topRail = tradStile;
      break;
    case "Euro":
      sideStiles = euroStile;
      topRail = euroStile;
      break;
    case "Slimline":
      if (doorType === "Swing") {
        sideStiles = requireTradLockStile ? 7.25 : 5.9375;
      } else {
        sideStiles = slimStile;
      }
      topRail =
        stiles &&
        stiles.includes("Slimline") &&
        doorType &&
        doorType.includes("Fritsjurgens")
          ? euroStile
          : slimStile;
      break;
    case "Slimline Traditional":
      sideStiles = slimStile;
      topRail = slimStile;
      break;
    case "Pico":
      if (doorType === "Swing") {
        if (swingDirection === "Outswing") {
          //Primary Hinge Side Stile: 1.25
          //Lock Hinge Side Stile: 1.875
          //Primary Hinge Side Stops: 0.625
          //Lock Hinge Side Stops: 0.625
          sideStiles = 4.375;
        } else if (swingDirection === "Inswing") {
          //Primary Hinge Side Stile: 1.25
          //Lock Hinge Side Stile: 2
          //Primary Hinge Side Stops: 0.625
          //Lock Hinge Side Stops: 0.625
          sideStiles = 4.5;
        }
      } else {
        sideStiles = picoStile;
      }
      //Top Rail: 1.25
      //Top Stops: 0.625
      //Total: 1.8755
      topRail = picoStile;
      break;
    default:
      sideStiles = 0;
      topRail = 0;
  }

  var glassWidth =
    (stiles === "Slimline" ||
      stiles === "Slimline Traditional" ||
      stiles === "Pico") &&
    doorType === "Swing"
      ? convertDecimalToFraction(panelWidth - sideStiles)
      : convertDecimalToFraction(panelWidth - 2 * sideStiles);

  const slimTradLockRail = '2-1/2" Stiles and Rails with 4-3/4" Lock Stile';
  const slimEuroLockRail = '2-1/2" Stiles and Rails with 3-7/16" Lock Stile';
  const slimSliderLockRail =
    '2-1/2" Stiles and Top Rails with 3-7/16" Lock Stile and Bottom Rails';

  const sqFt = (panelWidth * panelHeight) / 144;

  var bottomRail =
    stilesAndRails === 'Bottom rail 7"'
      ? 7
      : stilesAndRails === 'Bottom rail 4-3/4"'
        ? tradStile
        : stilesAndRails === "Euro | Contemporary" && sqFt > 50
          ? tradStile
          : stilesAndRails === "Euro | Contemporary" &&
              doorType === "Fritsjurgens Self Closing"
            ? tradStile
            : stilesAndRails === "Euro | Contemporary" ||
                lockRail === slimSliderLockRail
              ? euroStile
              : stiles &&
                  stiles.includes("Slimline") &&
                  doorType === "Fritsjurgens Self Closing"
                ? tradStile
                : stiles === "Pico" //Bottom Rail: 1.25  Bottom Stops:  0.625 Total: 1.875
                  ? picoStile
                  : slimStile;

  var glassHeight = convertDecimalToFraction(
    panelHeight - (topRail + bottomRail),
  );

  if (
    requireTradLockStile &&
    (stiles?.includes("Slimline") || stiles.includes("Euro"))
  ) {
    glassWidthDD = convertDecimalToFraction(
      panelWidth - (tradStile + sideStiles),
    );
  } else if (
    lockRail === slimTradLockRail ||
    lockRail === slimEuroLockRail ||
    lockRail === slimSliderLockRail
  ) {
    glassWidthDD = convertDecimalToFraction(
      panelWidth - (euroStile + slimStile),
    );
  } else if (stiles === "Pico") {
    glassWidthDD = convertDecimalToFraction(
      panelWidth - (picoStile + slimStile),
    );
  }

  return { glassHeight, glassWidth, glassWidthDD };
}

function calculateDLOAlum(
  doorType: string,
  exactConfig: string,
  panelWidth: number,
  panelHeight: number,
  fullboundProfile?: string,
  isSidelite?: boolean,
  swingDirection?: string,
  sill?: string,
) {
  let sub = 0;

  if (
    doorType === "Fixed Panel" ||
    (doorType.includes("Window") && !doorType.includes("Bi-fold"))
  ) {
    if (exactConfig === "Direct Glaze") {
      sub = 3;
    } else {
      if (exactConfig?.includes("Inswing")) {
        if (fullboundProfile === "Window Profile") {
          // sub = 4.625
          sub = 4.897308;
        } else {
          // sub = 6.96875
          sub = 6.582704;
        }
      } else {
        if (
          fullboundProfile === "Window Profile" ||
          doorType.includes("Window")
        ) {
          // sub = 5.21875
          sub = 4.897308;
        } else {
          // sub = 6.96875
          sub = 6.621414;
        }
      }
    }
  } else if (doorType === "Swing") {
    let widthSub = 0;
    let heightSub = 0;
    if (swingDirection === "Inswing") {
      widthSub = isSidelite ? 4.227954 : 6.59054;
      heightSub = isSidelite
        ? 4.227954
        : sill?.includes("Flat")
          ? 6.543295
          : 6.068448;
    } else {
      widthSub = isSidelite ? 4.803184 : 6.49605;
      heightSub = isSidelite ? 4.803184 : 6.49605;
    }
    return {
      glassHeight: convertDecimalToFraction(panelHeight - heightSub),
      glassWidth: convertDecimalToFraction(panelWidth - widthSub),
    };
    // sub = isSidelite ? 4.1875 : 6.5625
  } else if (doorType?.includes("Bi-fold")) {
    sub = 2 * 1.9291;
  }

  return {
    glassHeight: convertDecimalToFraction(panelHeight - sub),
    glassWidth: convertDecimalToFraction(panelWidth - sub),
  };
}

function findHandlePosition(config: string, numPanels: number) {
  const original = config;
  const numsArray: string[] = config
    .replace("L", "")
    .replace("R", "")
    .split("");

  const isEven = (num: string) => Number(num) % 2 === 0;

  if (numsArray.length === 1) {
    if (isEven(numsArray[0])) return false;

    const handleSide = original[1] === "L" ? "Right" : "Left";
    const panelWithHandle = original[1] === "L" ? numPanels : 1;
    return { numHandles: 1, handleSide, panelWithHandle };
  }

  let numEvens = 0;
  numsArray.forEach((num) => {
    if (isEven(num)) {
      numEvens++;
    }
  });

  if (numEvens === 2) return false;

  if (numEvens === 1) {
    const even = numsArray.find((num) => isEven(num));
    const odd = numsArray.find((num) => !isEven(num));
    const oddSide =
      original[original.split("").findIndex((itm: string) => itm === odd) + 1];
    const handleSide = oddSide === "L" ? "Right" : "Left";
    const panelWithHandle = oddSide === "L" ? Number(odd) : Number(even) + 1;
    return { numHandles: 1, handleSide, panelWithHandle };
  }

  return {
    numHandles: 2,
    handleSideLeft: "Right",
    handleSideRight: "Left",
    panelWithHandleLeft: Number(numsArray[0]),
    panelWithHandleRight: Number(numsArray[0]) + 1,
  };
}

function findHandlePositionSwing(
  exactConfig: string,
  exactConfigImg: string,
  isPico: boolean,
  secondaryHandle: string,
) {
  const hingeSide = exactConfig.includes("LH") ? "Left" : "Right";

  const handleSide = hingeSide === "Left" ? "Right" : "Left";
  if (exactConfig.includes("Single")) {
    if (exactConfig.includes("1 Sidelite")) {
      const lockside = exactConfigImg.includes("LOCK");

      if (hingeSide === "Left") {
        if (lockside) {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 1,
          };
        } else {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 2,
          };
        }
      } else {
        if (lockside) {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 2,
          };
        } else {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 1,
          };
        }
      }
    } else if (exactConfig.includes("2 Sidelite")) {
      return {
        numHandles: 1,
        handleSide,
        panelWithHandle: 2,
      };
    } else {
      return {
        numHandles: 1,
        handleSide,
        panelWithHandle: 1,
      };
    }
  } else {
    if (
      !isPico ||
      (isPico && secondaryHandle && secondaryHandle === "Matching Dummy Handle")
    ) {
      if (exactConfig.includes("2 Sidelite")) {
        return {
          numHandles: 2,
          handleSideLeft: "Right",
          handleSideRight: "Left",
          panelWithHandleLeft: 2,
          panelWithHandleRight: 3,
        };
      } else {
        return {
          numHandles: 2,
          handleSideLeft: "Right",
          handleSideRight: "Left",
          panelWithHandleLeft: 1,
          panelWithHandleRight: 2,
        };
      }
    } else {
      if (exactConfig.includes("2 Sidelite")) {
        return {
          numHandles: 1,
          handleSide,
          panelWithHandle: hingeSide === "Left" ? 2 : 3,
        };
      } else {
        return {
          numHandles: 1,
          handleSide,
          panelWithHandle: hingeSide === "Left" ? 1 : 2,
        };
      }
    }
  }
}

function findHandlePositionSwingAlum(
  exactConfig: string,
  exactConfigImg: string,
) {
  const hingeSide = exactConfig.includes("LH") ? "Left" : "Right";
  const handleSide = hingeSide === "Left" ? "Right" : "Left";
  const lockside = exactConfigImg.includes("LOCK");

  if (exactConfig.includes("Single")) {
    if (exactConfig.includes("1 Sidelite")) {
      if (hingeSide === "Left") {
        if (lockside) {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 1,
          };
        } else {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 2,
          };
        }
      } else {
        if (lockside) {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 2,
          };
        } else {
          return {
            numHandles: 1,
            handleSide,
            panelWithHandle: 1,
          };
        }
      }
    } else if (exactConfig.includes("2 Sidelite")) {
      return {
        numHandles: 1,
        handleSide,
        panelWithHandle: 2,
      };
    } else {
      return {
        numHandles: 1,
        handleSide,
        panelWithHandle: 1,
      };
    }
  } else {
    if (exactConfig.includes("2 Sidelite")) {
      return {
        numHandles: 1,
        handleSide,
        panelWithHandle: hingeSide === "Left" ? 2 : 3,
      };
    } else if (exactConfig.includes("1 Sidelite")) {
      return {
        numHandles: 1,
        handleSide,
        panelWithHandle:
          exactConfigImg?.includes("LEFT_SL") && hingeSide === "Left"
            ? 2
            : exactConfigImg?.includes("LEFT_SL") && hingeSide === "Right"
              ? 3
              : hingeSide === "Left"
                ? 1
                : 2,
      };
    } else {
      return {
        numHandles: 1,
        handleSide,
        panelWithHandle: hingeSide === "Left" ? 1 : 2,
      };
    }
  }
}

function findHandlePositionSlider(exactConfig: string, withPocket: boolean) {
  const doubleSided = exactConfig.includes("-");

  if (doubleSided) {
    const panelWithHandleLeft = exactConfig.split("-")[0].length;
    const panelWithHandleRight = panelWithHandleLeft + 1;

    return {
      numHandles: 2,
      handleSideLeft: "Right",
      handleSideRight: "Left",
      panelWithHandleLeft,
      panelWithHandleRight,
    };
  }

  if (withPocket) {
    const numHandles = 1;
    const handleSide = exactConfig[0] === "P" ? "Right" : "Left";

    if (handleSide === "Right") {
      const panelWithHandle = exactConfig.length;
      return {
        numHandles,
        handleSide,
        panelWithHandle,
      };
    } else {
      const panelWithHandle = 1;
      return {
        numHandles,
        handleSide,
        panelWithHandle,
      };
    }
  }

  if (exactConfig.includes("Primary")) {
    const numPanels = exactConfig.split(" ")[0].length;

    return {
      numHandles: 2,
      handleSideLeft: "Left",
      handleSideRight: "Right",
      panelWithHandleLeft: 1,
      panelWithHandleRight: numPanels,
    };
  }

  const numHandles = 1;
  const handleSide = exactConfig[0] === "O" ? "Right" : "Left";

  if (handleSide === "Right") {
    const panelWithHandle = exactConfig.length;
    return {
      numHandles,
      handleSide,
      panelWithHandle,
    };
  } else {
    const panelWithHandle = 1;
    return {
      numHandles,
      handleSide,
      panelWithHandle,
    };
  }
}

function findNumPanelsBifold(config: string): number {
  if (!config) return 1;
  const numsArray = config.replace("L", "").replace("R", "").split("");
  const numPanels = numsArray.reduce((a, b) => Number(a) + Number(b), 0);
  return numPanels;
}

function findNumPanelsSlider(config: string): number {
  if (!config) return 1;
  const numsArray = config.includes("Primary")
    ? config.split(" ")[0].split("")
    : config.replace("-", "").split("");
  const numPanels = numsArray.length;
  return numPanels;
}

function findNumPanelsSwing(swingType: string, sidelite: string): number {
  const active = swingType === "Pair Swing" ? 2 : 1;
  const fixed =
    sidelite === "none" ? 0 : sidelite === "Add Single Sidelite" ? 1 : 2;
  return active + fixed;
}

function findNumPanelsPivot(sidelite: string): number {
  const fixed =
    sidelite === "none" ? 0 : sidelite === "Add Single Sidelite" ? 1 : 2;
  return 1 + fixed;
}

interface FrameDimensions {
  headJamb: number;
  sill: number;
  jambLeg: number;
}

// Pico outswing: hinge side jamb is 1.125, lock side and sidelite outer jambs are 0.875
// (see calculateSwingWidths). True when a door hinge sits against the left frame jamb.
function picoHingeOnLeftJamb(exactConfig: string, exactConfigImg: string) {
  if (exactConfig.includes("2 Sidelite")) return false;
  if (!exactConfig.includes("Single")) return true; // pair, no sidelites
  if (!exactConfig.includes("LH")) return false;
  // LH with 1 sidelite: lockside image puts the sidelite on the right
  return exactConfig.includes("1 Sidelite")
    ? exactConfigImg.includes("LOCK")
    : true;
}

function frameDimensions(
  doorType: string,
  scale: number,
  swingDirection: string,
  hasSliderPocket: boolean,
  hasCentor: boolean,
  doubleSided: boolean,
  rightCornerJamb?: boolean,
  primarySide?: string,
  cornerType?: string,
  stiles?: string,
  exactConfig?: string,
  exactConfigImg?: string,
): FrameDimensions {
  if (doorType.includes("Corner")) {
    let jambLeg = 0;

    if (cornerType === "Inside") {
      if (hasCentor) {
        const isPico = stiles?.includes("Pico");
        jambLeg = isPico ? 4.25 : 3;
      } else {
        jambLeg =
          rightCornerJamb && primarySide === "Left"
            ? 2
            : rightCornerJamb && primarySide === "Right"
              ? 4.375
              : 0.9375;
      }
    } else {
      if (hasCentor) {
        const isPico = stiles?.includes("Pico");
        jambLeg = isPico ? 4.25 : 3;
      } else {
        jambLeg =
          rightCornerJamb && primarySide === "Left"
            ? 2.125
            : rightCornerJamb && primarySide === "Right"
              ? 4.375
              : 0.9375;
      }
    }

    return {
      headJamb: hasCentor ? 3.25 * scale : 2 * scale,
      sill: 0.9375 * scale,
      jambLeg: jambLeg * scale,
    };
  }

  if (doorType.includes("Bi-fold")) {
    //pico centor is 5.25
    const isPico = stiles?.includes("Pico");

    if (doorType?.includes("Combo") && rightCornerJamb) {
      // window combo
      return {
        headJamb: hasCentor ? 3.25 * scale : 2 * scale,
        sill: 0.9375 * scale,
        jambLeg: 0,
      };
    }

    return {
      headJamb: hasCentor ? 3.25 * scale : 2 * scale,
      sill: 0.9375 * scale,
      jambLeg:
        hasCentor && isPico
          ? 5.25 * scale
          : hasCentor
            ? 4 * scale
            : 0.9375 * scale,
    };
  }

  if (doorType === "Slider" || doorType === "Fixed Slider") {
    return {
      headJamb: hasCentor ? 3.125 * scale : 0.875 * scale,
      sill: 1 * scale,
      jambLeg:
        hasCentor && !hasSliderPocket
          ? (3.125 + 0.875) * scale
          : hasSliderPocket && hasCentor && !doubleSided
            ? 1.5625 * scale
            : hasSliderPocket
              ? 0
              : 0.9375 * scale,
    };
  }

  if (doorType === "Direct Glaze") {
    return {
      headJamb: 0,
      sill: 0,
      jambLeg: 0,
    };
  }

  if (doorType === "Fixed Full Bound") {
    return {
      headJamb: 0.875 * scale,
      sill: 0.5625 * scale,
      jambLeg: 0.875 * scale,
    };
  }

  if (
    doorType === "Swing" ||
    doorType === "Fixed Outswing" ||
    doorType === "Fixed Inswing"
  ) {
    if (swingDirection === "Outswing" || doorType === "Fixed Outswing") {
      // Pico panel height is netHeight - 1.7812 even with Centor, so no Centor head
      const isPico = stiles?.includes("Pico");
      const picoHingeJamb =
        isPico &&
        doorType === "Swing" &&
        picoHingeOnLeftJamb(exactConfig || "", exactConfigImg || "");
      return {
        headJamb: hasCentor && !isPico ? 2.5 * scale : 0.875 * scale,
        sill: 0.5625 * scale,
        jambLeg: ((hasCentor ? 3.125 : 0) + (picoHingeJamb ? 1.125 : 0.875)) * scale,
        // headJamb: hasCentor ? 2.5 * scale : 0.875 * scale,
        // sill: 0.5625 * scale,
        // jambLeg: hasCentor ? (3.125 + 0.875) * scale : 0.875 * scale,
      };
    }

    if (swingDirection === "Inswing" || doorType === "Fixed Inswing") {
      return {
        headJamb: 0.9375 * scale,
        sill: 1.125,
        jambLeg: 0.9375 * scale,
      };
    }
  }

  if (doorType === "Pivot") {
    return {
      headJamb: 0.9375 * scale,
      sill: 1.125,
      jambLeg: 0.9375 * scale,
    };
  }

  return {
    headJamb: 0,
    sill: 0,
    jambLeg: 0,
  };
}

function frameDimensionsAlum(
  doorType: string,
  scale: number,
  thickFrame: boolean,
  swingDirection: string,
  sillStyle: string,
  config: string,
  isCentor: boolean,
): FrameDimensions {
  if (doorType === "Direct Glaze") {
    return {
      headJamb: 0,
      sill: 0,
      jambLeg: 0,
    };
  }

  if (doorType === "Aluminum Swing") {
    //as viewed from exterior, ignoring overlap
    if (swingDirection === "Inswing") {
      const frame = (thickFrame ? 1.88976 : 1.515745) * scale;

      if (sillStyle?.includes("Flat")) {
        return {
          headJamb: frame,
          sill: 0.515625 * scale,
          jambLeg: frame,
        };
      } else {
        return {
          headJamb: frame,
          sill: 0.77575 * scale,
          jambLeg: frame,
        };
      }
    }
    //Outswing
    const frame = thickFrame ? 1.141732 : 0.767465;
    return {
      headJamb: frame * scale,
      sill: sillStyle?.includes("Flat") ? 0.51583 * scale : 0.296861 * scale,
      jambLeg: frame * scale,
    };
  }

  if (doorType === "Aluminum Fixed Full Bound Inswing Door") {
    const frame = 1.88976;
    return {
      headJamb: frame * scale,
      sill: frame * scale,
      jambLeg: frame * scale,
    };
  }

  if (doorType === "Aluminum Fixed Full Bound Inswing Window") {
    const frame = 1.515745;
    return {
      headJamb: frame * scale,
      sill: frame * scale,
      jambLeg: frame * scale,
    };
  }

  if (doorType === "Aluminum Fixed Full Bound Outswing Door") {
    const frame = 1.098404;
    return {
      headJamb: frame * scale,
      sill: frame * scale,
      jambLeg: frame * scale,
    };
  }

  if (doorType === "Aluminum Fixed Full Bound Outswing Window") {
    const frame = 0.720471;
    return {
      headJamb: frame * scale,
      sill: frame * scale,
      jambLeg: frame * scale,
    };
  }

  if (doorType?.includes("Bi-fold")) {
    let jamb = 0;

    const gap = 0.4724;
    const ADJUSTABLE_JAMB = 2.6378 + gap;

    if (config === "2L" || config === "2R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "3L" || config === "3R") {
      jamb = config === "3R" ? 2.0669 : ADJUSTABLE_JAMB;
    } else if (config === "4L" || config === "4R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "5L" || config === "5R") {
      jamb = config === "5R" ? 2.0669 : ADJUSTABLE_JAMB;
    } else if (config === "6L" || config === "6R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "7L" || config === "7R") {
      jamb = config === "7R" ? 2.0669 : ADJUSTABLE_JAMB;
    } else if (config === "1L2R" || config === "2L1R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "1L3R" || config === "3L1R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "1L4R" || config === "4L1R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "1L5R" || config === "5L1R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "1L6R" || config === "6L1R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "1L7R" || config === "7L1R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "2L3R" || config === "3L2R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "2L4R" || config === "4L2R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "2L5R" || config === "5L2R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "2L6R" || config === "6L2R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "3L4R" || config === "4L3R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "3L5R" || config === "5L3R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "2L2R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "3L3R") {
      jamb = ADJUSTABLE_JAMB;
    } else if (config === "4L4R") {
      jamb = ADJUSTABLE_JAMB;
    }

    if (isCentor) {
      jamb += 2.3125;
    }

    const headSillWithGasket = 1.5945;
    const headJamb = isCentor
      ? headSillWithGasket + 1.4375
      : headSillWithGasket;

    return {
      headJamb: headJamb * scale,
      sill: headSillWithGasket * scale,
      jambLeg: jamb * scale,
    };
  }

  return {
    headJamb: 0,
    sill: 0,
    jambLeg: 0,
  };
}

interface PocketSliderCalc {
  pocketSize: number;
  netWidth: number;
}

function pocketSliderCalc(
  doubleSided: boolean,
  daylightWidth: number,
  panelWidth: number,
): PocketSliderCalc {
  let pocketSize = roundHalf(panelWidth + 2.375);

  function roundHalf(num: number) {
    const half = Math.ceil(num * 2) / 2;

    return half;
  }

  const netWidth = doubleSided
    ? pocketSize + pocketSize + daylightWidth
    : pocketSize + daylightWidth;

  return { pocketSize, netWidth };
}

function handleImage(
  doorType: string,
  handle: string,
  handleSide: string,
  handleColor: string,
) {
  const URL =
    "https://res.cloudinary.com/ag-millworks/image/upload/Canvas/handles";

  if (doorType === "Pivot") {
    if (handle === "Handle Pull" || handle === "Handle Pull by Others") {
      return "";
    }
    if (handle.includes("Dallas")) {
      const color = handleColor.includes("Black") ? "Black" : "Steel";
      return `${URL}/Pivot/Dallas_${handleSide}_${color}.svg`;
    }
    const handleLbl = ["Axis", "Crest", "Strata"].includes(handle)
      ? "Round_Pull"
      : ["Strata", "Forge"].includes(handle)
        ? "Square_Pull"
        : handle;
    const color = handleColor.includes("Black") ? "_Black" : "_Steel";
    const side = handle === "Monarch" ? `_${handleSide}` : "";
    return `${URL}/Pivot/${handleLbl}${side}${color}.svg`;
  }

  if (doorType === "Slider") {
    if (handle.includes("Truth")) {
      const color = handleColor.replace(" PVD", "").split(" ").join("_");
      return `${URL}/Slider/Truth_${color}.svg`;
    }

    const color = handleColor
      .replace("(Resista Finish)", "")
      .replace(" *", "")
      .split(" ")
      .join("_");

    if (handle.includes("Dallas")) {
      return `${URL}/Slider/Dallas_${handleSide}_${color}.svg`;
    } else {
      return `${URL}/Slider/Verona_${handleSide}_${color}.svg`;
    }
  }

  if (handle.includes("*")) {
    const color = handleColor
      .replace("(Resista Finish)", "")
      .split(" ")
      .join("_");
    return `${URL}/Bifold_Swings/${handle
      .replace(" *", "")
      .replace(" ", "_")}_${handleSide}_${color}.svg`;
  }

  const color = handleColor
    .replace("(Resista Finish)", "")
    .replace(" *", "")
    .split(" ")
    .join("_");

  return `${URL}/Bifold_Swings/${handle.replace(
    " Handle",
    "",
  )}_${handleSide}_${color}.svg`;
}

function pivotBackPlateImage(backplate: string, backplateColor: string) {
  const URL =
    "https://res.cloudinary.com/ag-millworks/image/upload/Canvas/handles/Pivot";
  return `${URL}/${backplate.split(" ").join("_")}_${backplateColor.replace(
    " ",
    "_",
  )}.svg`;
}

function alumBifoldCylinderImage(handleColor: string) {
  const URL =
    "https://res.cloudinary.com/ag-millworks/image/upload/Canvas/handles/Bifold_Swings";
  return `${URL}/${handleColor.split(" ").join("_")}_Cylinder.svg`;
}

function getScale(
  doorType: string,
  netWidthCornerRight: number,
  netWidth: number,
  netHeight: number,
  canvasWidthVar: number,
  canvasHeightVar: number,
  sliderPocket: string,
  pocketSliderWidth: number,
) {
  const canvasSub = 200;
  const disclaimer = 30;

  const canvasWidth = canvasWidthVar - canvasSub - disclaimer;
  const canvasHeight = canvasHeightVar - canvasSub - disclaimer;

  const isCorner = doorType.includes("Corner");
  const isCombo = doorType.includes("Combo");

  if (isCorner) {
    const totalWidth = netWidth + netWidthCornerRight;

    if (totalWidth >= netHeight) {
      return (canvasWidth + 30) / totalWidth;
    }

    return (canvasHeight + 30) / netHeight;
  } else if (isCombo) {
    const totalWidth = netWidth + netWidthCornerRight;

    if (totalWidth >= netHeight) {
      return canvasWidth / totalWidth;
    }

    return canvasHeight / netHeight;
  }

  if (doorType === "Slider" && sliderPocket === "With Pocket") {
    if (pocketSliderWidth >= netHeight) {
      return canvasWidth / pocketSliderWidth;
    }

    return canvasHeight / netHeight;
  }

  if (doorType === "Swing" || doorType === "Pivot") {
    if (netWidth >= netHeight) {
      return canvasWidth / netWidth;
    }

    return canvasHeight / netHeight;
  }

  if (netWidth >= netHeight) {
    return canvasWidth / netWidth;
  }

  return canvasHeight / netHeight;
}

function getGaps(
  scale: number,
  doorType: string,
  exactConfig: string,
  exactConfigImg: string,
  isPico?: boolean,
) {
  if (doorType === "Swing") {
    if (exactConfig.includes("Outswing") && isPico) {
      // Matches calculateSwingWidths. Door gap: 0.1875 (3/16), middle gap: 0.125 (1/8)
      // Mullion = jamb + door gap: hinge 1.125 + 0.1875, lock 0.875 + 0.1875
      const doorGap = 0.1875 * scale;
      const hingeMullion = (1.125 + 0.1875) * scale;
      const lockMullion = (0.875 + 0.1875) * scale;
      const isLH = exactConfig.includes("LH");

      if (exactConfig.includes("Single")) {
        if (exactConfig.includes("1 Sidelite")) {
          const lockside = exactConfigImg.includes("LOCK");
          // door on the left when LH lockside or RH hinge side
          const doorFirst = isLH === lockside;
          return {
            panel1: doorFirst ? doorGap : 0,
            panel2: lockside ? lockMullion : hingeMullion,
          };
        } else if (exactConfig.includes("2 Sidelite")) {
          return {
            panel1: 0,
            panel2: isLH ? hingeMullion : lockMullion,
            panel3: isLH ? lockMullion : hingeMullion,
          };
        }
        return { panel1: doorGap };
      }

      if (exactConfig.includes("2 Sidelite")) {
        return {
          panel1: 0,
          panel2: hingeMullion,
          panel3: 0.125 * scale,
          panel4: hingeMullion,
        };
      }
      return { panel1: doorGap, panel2: 0.125 * scale };
    }

    if (!exactConfig.includes("Outswing") && isPico) {
      // Matches calculateSwingWidths. Door gap: 0.125 (1/8), middle gap: 0.0937 (3/32)
      // Mullion = door gap + sidelite jamb 0.9375 + door jamb 0.9375
      const doorGap = 0.125 * scale;
      const mullion = (0.125 + 0.9375 + 0.9375) * scale;

      if (exactConfig.includes("Single")) {
        if (exactConfig.includes("1 Sidelite")) {
          const lockside = exactConfigImg.includes("LOCK");
          // door on the left when LH lockside or RH hinge side
          const doorFirst = exactConfig.includes("LH") === lockside;
          return {
            panel1: doorFirst ? doorGap : 0,
            panel2: mullion,
          };
        } else if (exactConfig.includes("2 Sidelite")) {
          return { panel1: 0, panel2: mullion, panel3: mullion };
        }
        return { panel1: doorGap };
      }

      if (exactConfig.includes("2 Sidelite")) {
        return {
          panel1: 0,
          panel2: mullion,
          panel3: 0.0937 * scale,
          panel4: mullion,
        };
      }
      return { panel1: doorGap, panel2: 0.0937 * scale };
    }

    if (exactConfig.includes("Outswing")) {
      if (exactConfig.includes("Single")) {
        if (exactConfig.includes("1 Sidelite")) {
          const lockside = exactConfigImg.includes("LOCK");

          if (exactConfig.includes("LH")) {
            if (lockside) {
              return {
                panel1: 0.125 * scale,
                panel2: (0.125 + 0.875) * scale,
              };
            } else {
              return {
                panel1: 0,
                panel2: (0.125 + 0.875) * scale,
              };
            }
          } else {
            //RH
            if (lockside) {
              return {
                panel1: 0,
                panel2: (0.125 + 0.875) * scale,
              };
            } else {
              return {
                panel1: 0.125 * scale,
                panel2: (0.125 + 0.875) * scale,
              };
            }
          }
        } else if (exactConfig.includes("2 Sidelite")) {
          return {
            panel1: 0,
            panel2: (0.125 + 0.875) * scale,
            panel3: (0.875 + 0.125) * scale,
          };
        } else {
          return {
            panel1: 0.125 * scale,
          };
        }
      } else {
        if (exactConfig.includes("2 Sidelite")) {
          return {
            panel1: 0,
            panel2: (0.125 + 0.875) * scale,
            panel3: (0.9375 + 0.125) * scale,
            panel4: 0.875 * scale,
          };
        } else {
          return {
            panel1: 0.125 * scale,
            panel2: (0.9375 + 0.125) * scale,
          };
        }
      }
    } else {
      //Inswing
      if (exactConfig.includes("Single")) {
        if (exactConfig.includes("1 Sidelite")) {
          const lockside = exactConfigImg.includes("LOCK");

          if (exactConfig.includes("LH")) {
            if (lockside) {
              return {
                panel1: 0.0937 * scale,
                panel2: (0.0937 + 1.875) * scale,
              };
            } else {
              return {
                panel1: 0,
                panel2: (0.0937 + 1.875) * scale,
              };
            }
          } else {
            //RH
            if (lockside) {
              return {
                panel1: 0,
                panel2: (0.0937 + 1.875) * scale,
              };
            } else {
              return {
                panel1: 0.0937 * scale,
                panel2: (0.0937 + 1.875) * scale,
              };
            }
          }
        } else if (exactConfig.includes("2 Sidelite")) {
          return {
            panel1: 0,
            panel2: (0.0937 + 1.875) * scale,
            panel3: (1.875 + 0.0937) * scale,
          };
        } else {
          return {
            panel1: 0.0937 * scale,
          };
        }
      } else {
        if (exactConfig.includes("2 Sidelite")) {
          return {
            panel1: 0,
            panel2: (0.0937 + 1.875) * scale,
            panel3: (0.9375 + 0.0937) * scale,
            panel4: 1.875 * scale,
          };
        } else {
          return {
            panel1: 0.0937 * scale,
            panel2: (0.9375 + 0.0937) * scale,
          };
        }
      }
    }
  }

  if (doorType === "Pivot") {
    if (exactConfig.includes("1 Sidelite")) {
      const lockside = exactConfigImg.includes("LOCK");

      if (exactConfig.includes("LH")) {
        if (lockside) {
          return {
            panel1: 0.125 * scale,
            panel2: (2.875 - 0.5 + 0.0937) * scale,
          };
        } else {
          return {
            panel1: 0,
            panel2: (2.875 - 0.5 + 0.0937) * scale,
          };
        }
      } else {
        //RH
        if (lockside) {
          return {
            panel1: 0,
            panel2: (2.875 - 0.5 + 0.0937) * scale,
          };
        } else {
          return {
            panel1: 0.125 * scale,
            panel2: (2.875 - 0.5 + 0.0937) * scale,
          };
        }
      }
    } else if (exactConfig.includes("2 Sidelite")) {
      if (exactConfig.includes("LH")) {
        return {
          panel1: 0,
          panel2: (2.375 - 0.5 + 0.0937) * scale,
          panel3: (2.875 - 0.5 + 0.0937) * scale,
        };
      } else {
        return {
          panel1: 0,
          panel2: (2.875 - 0.5 + 0.0937) * scale,
          panel3: (2.375 - 0.5 + 0.0937) * scale,
        };
      }
    } else {
      if (exactConfig.includes("LH")) {
        return {
          panel1: 0.125 * scale,
        };
      } else {
        return {
          panel1: 0.0937 * scale,
        };
      }
    }
  }

  if (doorType.includes("Bi-fold")) {
    return {
      panel1: 0.125 * scale,
      panel2: 0.125 * scale,
      panel3: 0.125 * scale,
      panel4: 0.125 * scale,
      panel5: 0.125 * scale,
      panel6: 0.125 * scale,
      panel7: 0.125 * scale,
      panel8: 0.125 * scale,
    };
  }

  if (doorType === "Slider") {
    const panels = {};

    if (exactConfig.includes("Primary")) {
      const numPanels = exactConfig.split(" ")[0].length;
      for (let i = 0; i < numPanels; i++) {
        panels[`panel${i + 1}`] =
          i === 0 || i + 1 === numPanels ? 0.1875 * scale : 0;
      }
      return panels;
    }

    const doubleSided = exactConfig.includes("-");

    if (exactConfig.includes("P")) {
      //pocketing
      const config = exactConfig;
      const numPanels = config.replace("-", "").length;

      if (doubleSided) {
        const firstHandle = config.split("-")[0].length;
        for (let i = 0; i < numPanels; i++) {
          panels[`panel${i + 1}`] =
            i + 1 === firstHandle + 1 ? 0.1875 * scale : 0;
        }
        return panels;
      }

      const pocketSide = exactConfig[0] === "P" ? "Left" : "Right";
      for (let i = 0; i < numPanels; i++) {
        panels[`panel${i + 1}`] =
          (i === 0 && pocketSide === "Right") ||
          (i + 1 === numPanels && pocketSide === "Left")
            ? 0.1875 * scale
            : 0;
      }
      return panels;
    }

    const numPanels = exactConfig.replace("-", "").length;

    if (doubleSided) {
      const firstHandle = exactConfig.split("-")[0].length;

      for (let i = 0; i < numPanels; i++) {
        panels[`panel${i + 1}`] =
          i + 1 === firstHandle + 1 ? 0.1875 * scale : 0;
      }
      return panels;
    }

    const fixedPanelSide = exactConfig[0] === "O" ? "Left" : "Right";

    for (let i = 0; i < numPanels; i++) {
      panels[`panel${i + 1}`] =
        (i === 0 && fixedPanelSide === "Right") ||
        (i + 1 === numPanels && fixedPanelSide === "Left")
          ? 0.1875 * scale
          : 0;
    }
    return panels;
  }

  return {
    panel1: 0,
    panel2: 0,
    panel3: 0,
    panel4: 0,
    panel5: 0,
    panel6: 0,
    panel7: 0,
    panel8: 0,
  };
}

function picoShootbolt(withKey: boolean, sbColor: string) {
  const imgUrl =
    "https://res.cloudinary.com/ag-millworks/image/upload/Canvas/handles/Bifold_Swings";
  if (withKey) {
    return `${imgUrl}/Nano_Shootbolt_Cylinder_${sbColor?.replace(
      " ",
      "_",
    )}.svg`;
  }

  return `${imgUrl}/Nano_Shootbolt_${sbColor?.replace(" ", "_")}.svg`;
}

function picoShootboltPanels(config: string) {
  const leftMatch = config.match(/^(\d+)L/);
  const rightMatch = config.match(/L?(\d+)R$/);

  const numLeft = leftMatch ? parseInt(leftMatch[1]) : 0;
  const numRight = rightMatch ? parseInt(rightMatch[1]) : 0;

  const totalPanels = numLeft + numRight;
  const panels: number[] = [];

  if (numLeft) {
    if (numLeft !== 2 && numLeft % 2 === 0) {
      panels.push(1, numLeft);
    } else if (numLeft !== 1 && numLeft % 2 !== 0) {
      panels.push(1);
    }
  }

  if (numRight) {
    if (numRight !== 2 && numRight % 2 === 0) {
      panels.push(numLeft ? numLeft + 1 : 1);
      panels.push(numLeft ? totalPanels : numRight);
    } else if (numRight !== 1 && numRight % 2 !== 0) {
      panels.push(numLeft ? totalPanels : numRight);
    }
  }

  return panels;
}

function findOddOddShootboltPositionPicoWindow(config: string) {
  const numsArray: string[] = config
    .replace("L", "")
    .replace("R", "")
    .split("");

  if (numsArray.length <= 1) return null;

  const isEven = (num: string) => Number(num) % 2 === 0;

  let numEvens = 0;
  numsArray.forEach((num) => {
    if (isEven(num)) {
      numEvens++;
    }
  });

  if (numEvens > 0) return null;

  return {
    numHandles: 2,
    panelWithBoltLeft: Number(numsArray[0]),
    panelWithBoltRight: Number(numsArray[0]) + 1,
  };
}

function getGapsAlum(
  scale: number,
  doorType: string,
  exactConfig: string,
  exactConfigImg: string,
  alumThickFrame: boolean,
) {
  if (doorType === "Fixed Panel") {
    if (exactConfig === "Direct Glaze") {
      return { panel1: 0 };
    }
  }

  if (doorType === "Swing") {
    const direction = exactConfig?.includes("Inswing") ? "Inswing" : "Outswing";
    const gap =
      direction === "Inswing" && alumThickFrame
        ? (1.88976 + 1.88976) * scale
        : direction === "Inswing" && !alumThickFrame
          ? (1.515745 + 1.511567) * scale
          : direction === "Outswing" && alumThickFrame
            ? (1.141732 + 1.141732) * scale
            : direction === "Outswing" && !alumThickFrame
              ? (0.767465 + 0.767654) * scale
              : 0;

    if (exactConfig.includes("Single")) {
      if (exactConfig.includes("1 Sidelite")) {
        return {
          panel1: 0,
          panel2: gap,
        };
      } else if (exactConfig.includes("2 Sidelite")) {
        return {
          panel1: 0,
          panel2: gap,
          panel3: gap,
        };
      } else {
        return {
          panel1: 0,
        };
      }
    } else {
      if (exactConfig.includes("2 Sidelite")) {
        return {
          panel1: 0,
          panel2: gap,
          panel3: direction === "Inswing" ? gap / 2 : 0,
          panel4: gap,
        };
      } else if (exactConfig.includes("1 Sidelite")) {
        const sideliteSide = exactConfigImg?.includes("LEFT_SL")
          ? "left"
          : "right";

        if (sideliteSide === "left") {
          return {
            panel1: 0,
            panel2: gap,
            panel3: direction === "Inswing" ? 1.73228 * scale : 0,
          };
        } else {
          return {
            panel1: 0,
            panel2: direction === "Inswing" ? 1.73228 * scale : 0,
            panel3: gap,
          };
        }
      } else {
        return {
          panel1: 0,
          panel2: direction === "Inswing" ? 1.73228 * scale : 0,
        };
      }
    }
  }

  if (doorType.includes("Bi-fold")) {
    const gap = 0.4724;

    const isDoubleSided =
      exactConfig.includes("L") && exactConfig.includes("R");
    let doubleSidedGap = 0;

    const gapObj = {
      panel1: 0 * scale,
      panel2: gap * scale,
      panel3: gap * scale,
      panel4: gap * scale,
      panel5: gap * scale,
      panel6: gap * scale,
      panel7: gap * scale,
      panel8: gap * scale,
    };

    if (isDoubleSided) {
      const firstRightSidedPanel = Number(exactConfig.split("L")[0]) + 1;
      const otherGapConfigs = [
        "2L2R",
        "4L4R",
        "1L7R",
        "7L1R",
        "2L6R",
        "6L2R",
        "2L4R",
        "4L2R",
      ];
      if (otherGapConfigs.includes(exactConfig)) {
        doubleSidedGap = 1.7323;
      } else {
        doubleSidedGap = 1.4173;
      }
      gapObj[`panel${firstRightSidedPanel}`] = doubleSidedGap * scale;
    }

    return gapObj;
  }

  return {
    panel1: 0,
    panel2: 0,
    panel3: 0,
    panel4: 0,
    panel5: 0,
    panel6: 0,
    panel7: 0,
    panel8: 0,
  };
}

function panelHeightAlumPixels(
  scale: number,
  exactConfig: string,
  doorType: string,
  sillStyle: string,
  netHeight: number,
  swingDirection?: string,
  fullboundProfile?: string,
  alumThickFrame?: boolean,
) {
  //viewed from exterior measurements, ignore overlap
  var panelHeight = 0;

  if (
    doorType === "Fixed Panel" ||
    (!doorType.includes("Bi-fold") && doorType.includes("Window"))
  ) {
    if (exactConfig === "Direct Glaze") {
      panelHeight = netHeight - 0;
    } else {
      if (
        fullboundProfile === "Window Profile" ||
        doorType.includes("Window")
      ) {
        if (exactConfig?.includes("Outswing")) {
          panelHeight = netHeight - 1.440942;
        } else {
          panelHeight = netHeight - 3.03149;
        }
      } else {
        if (exactConfig?.includes("Outswing")) {
          panelHeight = netHeight - 2.196808;
        } else {
          panelHeight = netHeight - 3.77952;
        }
      }
    }
  } else if (doorType === "Swing") {
    if (alumThickFrame) {
      if (sillStyle?.includes("Flat")) {
        panelHeight =
          swingDirection === "Outswing"
            ? netHeight - 1.657722
            : netHeight - 2.405385;
      } else {
        panelHeight =
          swingDirection === "Outswing"
            ? netHeight - 1.441106
            : netHeight - 2.66551;
      }
    } else {
      //thin frame
      if (sillStyle?.includes("Flat")) {
        panelHeight =
          swingDirection === "Outswing"
            ? netHeight - 1.283295
            : netHeight - 2.03137;
      } else {
        panelHeight =
          swingDirection === "Outswing"
            ? netHeight - 1.064326
            : netHeight - 2.291495;
      }
    }
  } else if (doorType.includes("Bi-fold")) {
  }

  return panelHeight * scale;
}

function panelWidthAlumPixels(
  scale: number,
  exactConfig: string,
  doorType: string,
  width: number,
  swingDirection: string,
  fullboundProfile: string,
  alumThickFrame: boolean,
) {
  //viewed from exterior measurements, ignore overlap
  var panelWidthPixels = 0;

  if (
    doorType === "Fixed Panel" ||
    (!doorType.includes("Bi-fold") && doorType.includes("Window"))
  ) {
    //should pass in net width as "width"
    if (exactConfig === "Direct Glaze") {
      panelWidthPixels = width;
    } else {
      if (
        fullboundProfile === "Window Profile" ||
        doorType.includes("Window")
      ) {
        if (exactConfig?.includes("Outswing")) {
          panelWidthPixels = width;
        } else {
          panelWidthPixels = width - 1.590548;
        }
      } else {
        if (exactConfig?.includes("Outswing")) {
          panelWidthPixels = width;
        } else {
          panelWidthPixels = width - 1.582712;
        }
      }
    }
  } else if (doorType === "Swing") {
    //should pass in swingPanelWidth as "width"
    panelWidthPixels =
      swingDirection === "Outswing" ? width : width - 0.795274 * 2;
  } else if (doorType.includes("Bi-fold")) {
    panelWidthPixels = width;
  }

  return panelWidthPixels * scale;
}

function calcAlumSideliteHeightPixels(
  scale: number,
  netHeight: number,
  swingDirection?: string,
  alumThickFrame?: boolean,
) {
  var slHeight = 0;

  if (alumThickFrame) {
    slHeight =
      swingDirection === "Outswing"
        ? netHeight - 2.283464
        : netHeight - 3.779526;
  } else {
    slHeight =
      swingDirection === "Outswing"
        ? netHeight - 1.535413
        : netHeight - 3.023134;
  }

  return slHeight * scale;
}

function findEqualPanels(width: number, sub: number, numberOfPanels: number) {
  const equal = (width - sub) / numberOfPanels;
  return equal;
}

function calcSideliteWidthAlumPixels(
  scale: number,
  netWidth: number,
  direction: string,
  swingType: string,
  sideLite: string,
  panelWidth: number,
  equalPanels: boolean,
  thickAlum: boolean,
) {
  let slw = 0;

  if (direction === "Outswing") {
    if (swingType === "Single Swing") {
      switch (sideLite) {
        case "Add Single Sidelite":
          const oneSl = thickAlum ? 4.566928 : 3.070616;

          !equalPanels
            ? (slw = netWidth - panelWidth - oneSl)
            : (slw = findEqualPanels(netWidth, oneSl, 2));
          break;
        case "Add Double Sidelite":
          const twoSl = thickAlum ? 6.850392 : 4.605924;

          !equalPanels
            ? (slw = (netWidth - panelWidth - twoSl) / 2)
            : (slw = findEqualPanels(netWidth, twoSl, 3));
          break;
        default:
          return 0;
      }
    } else if (swingType === "Pair Swing") {
      switch (sideLite) {
        case "Add Single Sidelite":
          const oneSl = thickAlum ? 4.566928 : 3.070238;

          !equalPanels
            ? (slw = netWidth - 2 * panelWidth - oneSl)
            : (slw = findEqualPanels(netWidth, oneSl, 4));
          break;
        case "Add Double Sidelite":
          const twoSl = thickAlum ? 6.850392 : 4.605546;

          !equalPanels
            ? (slw = (netWidth - 2 * panelWidth - twoSl) / 2)
            : (slw = findEqualPanels(netWidth, twoSl, 4));
          break;
        default:
          return 0;
      }
    }
  } else if (direction === "Inswing") {
    if (swingType === "Single Swing") {
      switch (sideLite) {
        case "Add Single Sidelite":
          const oneSl = thickAlum ? 7.55894 : 6.06298;

          !equalPanels
            ? (slw = netWidth - panelWidth - oneSl)
            : (slw = findEqualPanels(netWidth, oneSl, 2));
          break;
        case "Add Double Sidelite":
          const twoSl = thickAlum ? 11.33841 : 9.09447;

          !equalPanels
            ? (slw = (netWidth - panelWidth - twoSl) / 2)
            : (slw = findEqualPanels(netWidth, twoSl, 3));
          break;
        default:
          return 0;
      }
    } else if (swingType === "Pair Swing") {
      switch (sideLite) {
        case "Add Single Sidelite":
          const oneSl = thickAlum ? 9.29122 : 7.79526;

          !equalPanels
            ? (slw = netWidth - 2 * panelWidth - oneSl)
            : (slw = findEqualPanels(netWidth, oneSl, 4));
          break;
        case "Add Double Sidelite":
          const twoSl = thickAlum ? 13.07069 : 10.82675;

          !equalPanels
            ? (slw = (netWidth - 2 * panelWidth - twoSl) / 2)
            : (slw = findEqualPanels(netWidth, twoSl, 4));
          break;
        default:
          return 0;
      }
    }
  }

  return slw * scale;
}

export {
  findOddOddShootboltPositionPicoWindow,
  picoShootboltPanels,
  pocketSliderCalc,
  findHandlePosition,
  findHandlePositionSwing,
  findNumPanelsBifold,
  findNumPanelsSlider,
  calculateDLO,
  findNumPanelsSwing,
  frameDimensions,
  findNumPanelsPivot,
  handleImage,
  getScale,
  getGaps,
  findHandlePositionSlider,
  pivotBackPlateImage,
  alumBifoldCylinderImage,
  picoShootbolt,
  calculateDLOAlum,
  frameDimensionsAlum,
  findHandlePositionSwingAlum,
  panelHeightAlumPixels,
  calcAlumSideliteHeightPixels,
  panelWidthAlumPixels,
  calcSideliteWidthAlumPixels,
  getGapsAlum,
};
